module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Richard Connell\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Richard Connell (1893–1949) was an American author and journalist best remembered for his short story “The Most Dangerous Game” (1924). Connell was one of the most popular American short story writers of his time, and his stories were published in the"), _c('I', [_vm._v(" Saturday Evening Post")]), _vm._v(" and "), _c('I', [_vm._v("Collier’s")]), _vm._v(" magazines. He had equal success as a journalist and screenwriter, and his screenplay for the movie "), _c('I', [_vm._v("Meet John Doe")]), _vm._v(" was nominated for an Academy Award in 1942.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/xZgKme/tc-custom/9781504062633.jpg?1737160398429",
      "alt": "This image is the cover for the book Most Dangerous Game"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Most Dangerous Game\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("From one of America’s most popular short story writers and an Academy Award nominee: the O. Henry Award–winning tale that inspired the movie "), _c('i', [_vm._v("The Hunt")]), _vm._v(".")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" A subject of mysterious rumors and superstition, the deserted Caribbean Island was shrouded in an air of peril. To Sanger Rainsford, who fell off a yacht and washed up on its shores, the abandoned isle was a welcome paradise. But unknown to the big-game hunter, a predator lurked in its lush jungles—one more dangerous than any he had ever encountered: a human."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" First published in 1924, this suspenseful tale “has inspired serial killers, films and stirred controversy in schools. A century on, the story continues to thrill” ("), _c('i', [_vm._v("The Telegraph")]), _vm._v(")."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “[A] tense, relentless story of man-against-man adventure, in which the hunter Sanger Rainsford learns, at the hands of General Zaroff, what it means to be hunted.” —"), _c('i', [_vm._v("Criterion")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0